import React, {Component} from 'react'
import $ from 'jquery';
import server from '../server';

import {Link} from "react-router-dom";

class MenuBar extends Component{
    state = {
        drawer : false,
        menu:false,
        modal:false,
        left: 0,
        mobile:false,
    }

    componentWillMount(){
        const name = JSON.parse(localStorage.getItem("user")).name;
        this.setState({name:name});
    }

    componentDidMount(){
        if(window.innerWidth < 990) this.setState({mobile:true,left:1});
        $('.sidebar .sidebar-menu li a').on('click', function () {
            const $this = $(this);
        
            if ($this.parent().hasClass('open')) {
              $this
                .parent()
                .children('.dropdown-menu')
                .slideUp(200, () => {
                  $this.parent().removeClass('open');
                });
            } else {
              $this
                .parent()
                .parent()
                .children('li.open')
                .children('.dropdown-menu')
                .slideUp(200);
        
              $this
                .parent()
                .parent()
                .children('li.open')
                .children('a')
                .removeClass('open');
        
              $this
                .parent()
                .parent()
                .children('li.open')
                .removeClass('open');
        
              $this
                .parent()
                .children('.dropdown-menu')
                .slideDown(200, () => {
                  $this.parent().addClass('open');
                });
            }
          });
        
          // Sidebar Activity Class
          const sidebarLinks = $('.sidebar').find('.sidebar-link');
        
          sidebarLinks
            .each((index, el) => {
              // $(el).removeClass('active');
            })
            .filter(function () {
              const href = $(this).attr('href');
              const pattern = href[0] === '/' ? href.substr(1) : href;
              return pattern === (window.location.pathname).substr(1);
            })
            .addClass('active');
        
          // ٍSidebar Toggle
          $('.sidebar-toggle').on('click', e => {
            $('.app').toggleClass('is-collapsed');
            console.log($( window ).width())
           
            if($( window ).width()< 992){
            }
            // $('.page-container').toggleClass('overlay-blur');
            
            
            e.preventDefault();
          });
        
          /**
           * Wait untill sidebar fully toggled (animated in/out)
           * then trigger window resize event in order to recalculate
           * masonry layout widths and gutters.
           */
          $('#sidebar-toggle').click(e => {
            console.log($( window ).width())
            e.preventDefault();
            ()=>setTimeout(() => {
                console.log($(window.event))
              window.dispatchEvent(window.event);
            }, 300);
          });
    }

    toggle_menu = () =>{
      if(this.state.mobile) this.state.left == 0 ? this.setState({left:1}) : this.setState({left:0});
    }

    load_pages = () =>{
        const type = server.userType;
        let content = [];
        let mobile = [];

        const pages = {
          secretary:["Agendar", "Clínica", "Pacientes" , "Suas Indicações", "Fale com a Blues"],
          doctor:[ "Pacientes", "Suas Indicações", "Clínica", "Fale com a Blues"],
          fisioterapist:["Agenda","Atender", "Pacientes", "Suas Consultas" ,"Cadastrar Clínica", "Fale com a Blues"],
          patient:["Evolução","Suas Consultas", "Fale com a Blues"]
        }

        const icons = {
            "Atender":"fa fa-user-md",
            "Agenda":"fa fa-calendar-check-o",
            "Agendar":"fa fa-calendar-check-o",
            "Pacientes":"fa fa-stethoscope",
            "Cadastrar Clínica":"fa fa-hospital-o",
            "Clínica": "fa fa-hospital-o",
            "Financeiro": "fa fa-dollar",
            "Fale com a Blues": "fa fa-phone",
            "Suas Indicações": "fa fa-heartbeat",
            "Suas Consultas": "fa fa-heartbeat",
            "Evolução": "fa fa-medkit"
        }
        for(let page in pages[type]){
            content.push(<li onClick={() =>{this.toggle_menu(); this.props.changePage(pages[type][page])}} class="nav-item">
                            <a href="#/home" class="sidebar-link">
                                <span class="icon-holder">
                                    <i class={icons[pages[type][page]]}></i>
                                </span>
                                <span class="title">{pages[type][page]}</span>
                            </a>
                         </li>);
            if(mobile.length < 4)
              mobile.push(<li onClick={() =>{this.props.changePage(pages[type][page])}} class="mobile-nav__item d-n@sm+">
                              <a href="#/home" class={this.props.currentPage == pages[type][page] ? "sidebar-link active" : "sidebar-link"}>
                                  <span class="icon-holder">
                                      <i class={icons[pages[type][page]]}></i>
                                  </span>
                              </a>
                          </li>)
        }

        return {"desktop":content,"mobile":mobile, "user_type": type};
    }

    render(){
        const pages = this.load_pages();
        const user_type = {
          "fisioterapist": "Fisioterapeuta",
          "secretary": "Secretária",
          "doctor": "Médico",
          "patient": "Paciente"
        }

        return(
          <div class="app-layout" id="app-layout">
            <div style={{left: this.state.left * -230, zIndex:1000000}} class="sidebar bdR">
              <div class="sidebar-inner">
                <div class="sidebar-logo bdR-0">
                  <div class="peers ai-c fxw-nw">
                    <a class="td-n" href="index.html">
                      <div class="peers ai-c fxw-nw">
                        <div class="peers jc-c w-100p">
                          <div class="logo">
                            <img src="assets/images/logo-white.svg" alt=""/>
                          </div>
                        </div>
                      </div>
                    </a>
                    <div class="peer">
                      <div class="mobile-toggle sidebar-toggle">
                        <a onClick={this.toggle_menu} href="" class="td-n">
                          <i class="fa fa-close"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="sidebar-profile peers">
                  <div class="sidebar-profile__image">
                    <img src={server.imagePath + "/profile/" + server.user.profilePicture} alt=""/>
                  </div>
                  <div class="sidebar-profile__name ta-l">
                    <span class="c-white">{this.state.name.split(" ")[0]}</span>
                    <span class="fsz-xs c-client-default-inverse">{user_type[server.userType]}</span>

                    <a onClick={() =>{this.toggle_menu(); this.props.changePage("Minha Conta")}} class="account-link">
                      <button class="btn btn-clear c-client-default-secondary">
                        Editar
                        <i class="fa fa-pencil c-client-default-secondary fsz-sm "></i>
                      </button>
                    </a>


                  </div>
                </div>

                <ul class="sidebar-menu scrollable pos-r">
                  {pages.desktop}
                </ul>
                <Link to="/" onClick={() => this.props.changePage(-1)} class="btn cur-p btn-clear pY-10">
                  Sair
                </Link>

              </div>
            </div>
            <div onClick={this.toggle_menu} class="sidebar-bcg-overlay sidebar-toggle"></div>

            <div class="page-container">
              <div class="header navbar bdrs-0">

                <div class="header-container bdB">
                  <div style={{width:" 100%", display: "flex", justifyContent: "space-between"}}>
                    <ul class="nav-left">
                      <li>
                        <a onClick={this.toggle_menu} id='sidebar-toggle' class="sidebar-toggle" href="javascript:void(0);">
                          <i class="fa fa-bars"></i>
                        </a>
                      </li>
                    </ul>

                    <ul class="mobile-nav">
                      {pages.mobile}
                    </ul>
                    <ul class="nav-right top-nav">
                      <li class="notifications">
                        <a onClick={() => this.props.changePage("Faq")} class="no-after">
                          <i class="fa fa-question-circle"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <main class="full-container">
                <div id="app-content">
                  {this.props.content}
                </div>
              </main>
            </div>
          </div>
        )
    }
}

export default MenuBar



// WEBPACK FOOTER //
// ./src/global/Menu.js